<ng-container *transloco="let t; read: 'companies'">

  <div class="componentContainer">
    <section class="xs12col componentHeader">
      <h1>{{ company ? company.name : t('titleSingular') }}</h1>
    </section>

    <kendo-tabstrip (tabSelect)="onTabSelect($event)">
      <kendo-tabstrip-tab [title]="t('companyTab')" [selected]="('Permissions.Companies.Update' | permission)" [disabled]="!('Permissions.Companies.Update' | permission)">
        <ng-template kendoTabContent>
          <section class="oneCol">
            <div class="xs12col">
              <div class="boxContainer">
                <h2 class="padding-bottom-medium">{{t('companyInfo')}}</h2>
                <form [formGroup]="form" (submit)="onSubmit()">
                  <kendo-formfield>
                    <kendo-label [text]="t('companyName')"></kendo-label>
                    <kendo-textbox
                      formControlName="name"
                      [readonly]="false"
                    ></kendo-textbox>
                    @if (form.get('name').hasError('required')) {
                      <kendo-formerror
                      >{{t('isRequired')}}</kendo-formerror>
                    }
                  </kendo-formfield>

                  <kendo-formfield>
                    <kendo-label [text]="t('tenantId')"></kendo-label>
                    <kendo-textbox
                      formControlName="tenantId"
                      [readonly]="true"
                    ></kendo-textbox>
                  </kendo-formfield>

                  <kendo-formfield>
                    <kendo-label [text]="t('internalNumber')"></kendo-label>
                    <kendo-textbox formControlName="internalNumber"></kendo-textbox>
                    @if (form.get('internalNumber').hasError('companyInternalNumberExists')) {
                      <kendo-formerror
                      >{{t('companyInternalNumberExists')}}</kendo-formerror>
                    }
                    @if (form.get('internalNumber').hasError('required')) {
                      <kendo-formerror
                      >{{t('isRequired')}}</kendo-formerror>
                    }
                  </kendo-formfield>

                  <kendo-formfield>
                    <kendo-label
                      [text]="t('orderCopyEmail')"
                    ></kendo-label>
                    <kendo-textbox
                      formControlName="orderCopyEmail"
                    ></kendo-textbox>
                    @if (form.get('orderCopyEmail').hasError('email')) {
                      <kendo-formerror
                      >{{t('emailWrongFormat')}}</kendo-formerror>
                    }
                  </kendo-formfield>
                  <div class="buttonContainer">
                    <button
                      kendoButton
                      class="buttonPrimary"
                      type="submit"
                      [disabled]="form.status === 'INVALID' || !form.dirty">
                      {{t('save')}}
                    </button>
                  </div>
                </form>
              </div>
            </div>

          </section>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="t('employeeTab')" [selected]="false" [disabled]="!('Permissions.Employees.Update' | permission)">
        <ng-template kendoTabContent>
          <section class="oneCol">
            <div class="xs12col">
              <div class="boxContainer">

                <h2 class="padding-bottom-medium">{{t('employees')}}</h2>
                <app-company-employees
                  [company]="company">
                </app-company-employees>
              </div>
            </div>
          </section>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="t('deviceLocationsTab')" [selected]="false"  [disabled]="!('Permissions.DeviceLocations.Update' | permission)">
        <ng-template kendoTabContent>
          <section class="oneCol">
            <div class="xs12col">
              <div class="boxContainer">

                <app-device-locations
                  [company]="company">
                </app-device-locations>
              </div>
            </div>
          </section>
        </ng-template>
      </kendo-tabstrip-tab>

      <kendo-tabstrip-tab [title]="t('cabinetsTab')" [selected]="!('Permissions.Companies.Update' | permission)">
        <ng-template kendoTabContent>
          <section class="oneCol">
            <div class="xs12col">
              <div class="boxContainer">
                <app-cabinet-view-admin
                  [company]="company">
                </app-cabinet-view-admin>
              </div>
            </div>
          </section>
        </ng-template>
      </kendo-tabstrip-tab>
    </kendo-tabstrip>
  </div>
</ng-container>
